
  import { mapState, mapGetters } from 'vuex'
  import finance from '~/mixins/common/pages/finance'
  export default {
    mixins: [finance],
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      parentSteppers: {
        type: Number,
        default: null
      },
      parentResultData: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        steppers: 1,
        attentionDialog: false,
        insufficientBalanceDialog: false,
        cryptoForm: {
          currency: null,
          amount: null
        },
        formattedAmount: {
          cryptoAmount: ''
        },
        resultData: {}
      }
    },
    computed: {
      ...mapState({
        loading: state => state.themes.withdraw.loading,
        player: state => state.player.player,
        verifyCurrency: state => state.banks.verifyCurrency,
        cryptoCurrencyList: state => state.settings.cryptoWalletAddressList,
        playerCryptoWallets: state => state.themes['player-bank'].playerCryptoWallets,
        exchangeRateLoading: state => state.themes.settings.exchangeRateLoading,
        exchangeRateByPlayerCurrency: state => state.themes.settings.exchangeRateByPlayerCurrency,
        companyCryptoWalletForWithdrawal: state =>
          state.themes.withdraw.companyCryptoWalletForWithdrawal,
        operationSetting: state => state.settings.operationSetting
      }),
      ...mapGetters({
        bankAccount: 'themes/player-bank/bankAccount',
        swapAllExchangeRate: 'themes/settings/swapAllExchangeRate'
      }),
      cryptoExchangeRate() {
        if (this.exchangeRateLoading) return ''
        if (this.exchangeRateByPlayerCurrency.rate)
          return parseFloat(this.exchangeRateByPlayerCurrency.rate)
        return 1
      },
      cryptoTransferAmount() {
        if (!this.cryptoForm.amount || this.exchangeRateLoading) return ''
        return this.formatCurrencyJS(this.cryptoForm.amount * this.cryptoExchangeRate)
      },
      formRule() {
        return [
          v => !!v || this.tr(this.FRONTEND_ERROR_CODES.amountIsRequired),
          v =>
            parseFloat(v?.toString()?.replace(/,/g, '')) > 0 ||
            `${this.tr(this.FRONTEND_ERROR_CODES.amountGreaterThanZero)}`,
          v =>
            parseFloat(v?.toString()?.replace(/,/g, '')) <=
              parseFloat(this.playerRealtimeBalance()) ||
            `${this.tr(this.FRONTEND_ERROR_CODES.balanceInsufficient)}`,
          v =>
            (v && parseFloat(v?.toString()?.replace(/,/g, ''))) >=
              parseFloat(this.operationSetting?.withdraw_min) ||
            `${this.tr(this.FRONTEND_ERROR_CODES.minimumWithdrawIs)} ${this.formatCurrencyJS(
              this.operationSetting.withdraw_min
            )}`,
          v =>
            (v && parseFloat(v?.toString()?.replace(/,/g, ''))) <=
              parseFloat(this.operationSetting?.withdraw_max) ||
            `${this.tr(this.FRONTEND_ERROR_CODES.maximumWithdrawIs)} ${this.formatCurrencyJS(
              this.operationSetting.withdraw_max
            )}`,
          v => this.decimalRule(v) || this.tr(this.FRONTEND_ERROR_CODES.decimalIsTwoDigit)
        ]
      }
    },
    watch: {
      cryptoCurrencyList(value) {
        if (value.length) {
          this.cryptoForm.currency = value[0].code
        }
      },
      parentSteppers(value) {
        this.steppers = value
      },
      parentResultData: {
        deep: true,
        handler(value) {
          this.resultData = { ...value }
        }
      },
      playerCryptoWallets(value) {
        if (value.length > 0) {
          this.cryptoForm.player_crypto_wallet_id = value[0]?.id
        }
      }
    },
    mounted() {
      if (this.$cookie.get('player')?.currency !== 'USDT')
        this.$store.dispatch('themes/settings/getExchangeRateByPlayerCurrency', {
          currency: this.$cookie.get('player')?.currency
        })
      if (!this.cryptoCurrencyList.length) {
        this.$store.dispatch('settings/getCryptoWalletAddressList')
      } else {
        this.cryptoForm.currency = this.cryptoCurrencyList[0].code
      }
      if (!this.playerCryptoWallets.length) {
        this.$store.dispatch('themes/player-bank/playerCryptoWallet')
      }
      if (this.parentSteppers) {
        this.steppers = this.parentSteppers
      }
      if (this.parentResultData) {
        this.resultData = this.parentResultData
      }
      this.$root.withdrawExistChange = item => {
        if (!item?.is_exist) {
          this.steppers = 1
          this.$emit('update:parentSteppers', 1)
          this.resultData = {}
        } else {
          this.steppers = 2
          this.$emit('update:parentSteppers', 2)
          this.resultData = { ...item }
        }
      }
      if (this.playerCryptoWallets.length > 0) {
        this.cryptoForm.player_crypto_wallet_id = this.playerCryptoWallets[0]?.id
      }
    },
    destroyed() {
      this.$root.withdrawExistChange = null
    },
    methods: {
      closeAttention() {
        this.attentionDialog = false
        this.insufficientBalanceDialog = true
      },
      onInputAmount(amount) {
        if (isNaN(amount?.replace(/,/g, ''))) {
          this.cryptoForm.amount = '0'
          return
        }
        const formattedAmount = amount
          ? Number.parseFloat(amount?.replace(/,/g, ''))?.toLocaleString()
          : ''

        this.formattedAmount.cryptoAmount = formattedAmount
        this.cryptoForm.amount = formattedAmount?.toString()?.replace(/,/g, '')
      },
      async onCreateCryptoWithdrawal() {
        if (!this.$refs.cryptoForm.validate()) return null
        // Track withdrawal
        await this.trackWithdrawEvent(this.cryptoForm.amount)

        const response = await this.$store.dispatch('themes/withdraw/createCryptoWithdrawal', {
          amount: this.cryptoForm.amount,
          player_crypto_wallet_id: this.cryptoForm.player_crypto_wallet_id
        })
        if (response) {
          this.resultData = response
          this.steppers++
          this.$emit('update:parentSteppers', 2)
        }
      },
      async cancelPending(item) {
        const confirm = window.confirm(this.tl('uSureToCancel?'))
        if (!confirm) return
        const result = await this.$store.dispatch('themes/withdraw/cancelWithdraw', item.id)
        if (result) {
          this.$toast.error(this.tl(result.message))
          this.resultData = {}
          this.steppers = 1
          this.$emit('update:parentSteppers', 1)
        }
      }
    }
  }
